module.exports = __webpack_public_path__ + "img/news-bg.c7d18adf.png";